// @ts-nocheck
import {
  CLOSE_DIRECT_SMS_MODAL,
  CLOSE_REPORT_MODAL,
  CLOSE_SEND_SMS_MODAL,
  CLOSE_SEND_SMS_MODAL_WITH_HISTORY,
  CLOSE_SMS_MODAL,
  FETCH_OLDER_SMS_FAILURE,
  FETCH_OLDER_SMS_REQUEST,
  FETCH_OLDER_SMS_SUCCESS,
  FETCH_PEOPLE_FOR_SMS_FAILURE,
  FETCH_PEOPLE_FOR_SMS_REQUEST,
  FETCH_PEOPLE_FOR_SMS_SUCCESS,
  OPEN_DIRECT_SMS_MODAL,
  OPEN_REPORT_MODAL,
  OPEN_SEND_SMS_MODAL,
  OPEN_SEND_SMS_MODAL_DIRECT,
  OPEN_SMS_MODAL,
  REPORT_CONTRACTOR_FAILURE,
  REPORT_CONTRACTOR_REQUEST,
  REPORT_CONTRACTOR_SUCCESS,
  SEND_SMS_FAILURE,
  SEND_SMS_REQUEST,
  SEND_SMS_SUCCESS,
  TRIGGER_EMAIL_CONSENT_FAILURE,
  TRIGGER_EMAIL_CONSENT_REQUEST,
  TRIGGER_EMAIL_CONSENT_SUCCESS,
  TRIGGER_SMS_CONSENT_FAILURE,
  TRIGGER_SMS_CONSENT_REQUEST,
  TRIGGER_SMS_CONSENT_SUCCESS,
  UNFLAG_CONTRACTOR_FAILURE,
  UNFLAG_CONTRACTOR_REQUEST,
  UNFLAG_CONTRACTOR_SUCCESS,
  UNRESTRICT_CONTRACTOR_FAILURE,
  UNRESTRICT_CONTRACTOR_REQUEST,
  UNRESTRICT_CONTRACTOR_SUCCESS,
} from "../../constants/sms/sms";

const initialState = {
  smsModalStatus: false,
  sendSmsModalStatus: false,
  people: [],
  initialPeople: [],
  smsHistory: [],
  senderId: null,
  isLoading: false,
  reportLoading: false,
  smsHistoryLoading: false,
  peopleLoading: false,
  consetEmailLoading: false,
  consetSMSLoading: false,
  reportModalStatus: false,
  reportTitle: null,
  reportUser: null,
  directSmsModalStatus: false,
  directSmsModalData: null,
};

const smsReducer = (state = initialState, action) => {
  switch (action?.type) {
    // open sms
    case OPEN_SMS_MODAL:
      return {
        ...state,
        smsModalStatus: true,
      };

    case CLOSE_SMS_MODAL:
      return {
        ...state,
        smsModalStatus: false,
        initialPeople: [],
        senderId: null,
      };

    // open send sms
    case OPEN_SEND_SMS_MODAL:
      return {
        ...state,
        sendSmsModalStatus: true,
      };

    case CLOSE_SEND_SMS_MODAL:
      return {
        ...state,
        sendSmsModalStatus: false,
      };

    case CLOSE_SEND_SMS_MODAL_WITH_HISTORY:
      return {
        ...state,
        sendSmsModalStatus: false,
        smsModalStatus: false,
      };

    case OPEN_SEND_SMS_MODAL_DIRECT:
      return {
        ...state,
        smsModalStatus: true,
        sendSmsModalStatus: true,
        initialPeople: action?.payload?.people || [],
        isDM: action?.payload?.isDM || false,
      };

    // sms send action
    case SEND_SMS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case SEND_SMS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case SEND_SMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    // fetch people for sms
    case FETCH_PEOPLE_FOR_SMS_REQUEST:
      return {
        ...state,
        peopleLoading: true,
      };

    case FETCH_PEOPLE_FOR_SMS_FAILURE:
      return {
        ...state,
        peopleLoading: false,
      };
    case FETCH_PEOPLE_FOR_SMS_SUCCESS:
      return {
        ...state,
        peopleLoading: false,
        people: action?.payload,
      };

    // report modal open and close
    case OPEN_REPORT_MODAL:
      return {
        ...state,
        reportModalStatus: true,
        reportUser: action?.payload,
      };

    case CLOSE_REPORT_MODAL:
      return {
        ...state,
        reportModalStatus: false,
        reportUser: null,
      };

    // report request status
    case REPORT_CONTRACTOR_REQUEST:
      return {
        ...state,
        reportLoading: true,
      };

    case REPORT_CONTRACTOR_FAILURE:
      return {
        ...state,
        reportLoading: false,
      };

    case REPORT_CONTRACTOR_SUCCESS:
      return {
        ...state,
        reportLoading: false,
      };

    // unflag request status
    case UNFLAG_CONTRACTOR_REQUEST || UNRESTRICT_CONTRACTOR_REQUEST:
      return {
        ...state,
        reportLoading: true,
      };

    case UNFLAG_CONTRACTOR_FAILURE || UNRESTRICT_CONTRACTOR_FAILURE:
      return {
        ...state,
        reportLoading: false,
      };

    case UNFLAG_CONTRACTOR_SUCCESS || UNRESTRICT_CONTRACTOR_SUCCESS:
      return {
        ...state,
        reportLoading: false,
      };

    // sms history fetching
    case FETCH_OLDER_SMS_REQUEST:
      return {
        ...state,
        smsHistoryLoading: true,
      };

    case FETCH_OLDER_SMS_FAILURE:
      return {
        ...state,
        smsHistoryLoading: false,
      };

    case FETCH_OLDER_SMS_SUCCESS:
      return {
        ...state,
        smsHistoryLoading: false,
        smsHistory: action?.payload?.data,
      };

    // open direct sms modal
    case OPEN_DIRECT_SMS_MODAL:
      return {
        ...state,
        directSmsModalStatus: true,
        directSmsModalData: action?.payload?.data,
      };

    case CLOSE_DIRECT_SMS_MODAL:
      return {
        ...state,
        directSmsModalStatus: false,
        directSmsModalData: null,
      };

    // consent email
    case TRIGGER_EMAIL_CONSENT_REQUEST:
      return {
        ...state,
        consetEmailLoading: true,
      };
    case TRIGGER_EMAIL_CONSENT_SUCCESS:
      return {
        ...state,
        consetEmailLoading: false,
      };
    case TRIGGER_EMAIL_CONSENT_FAILURE:
      return {
        ...state,
        consetEmailLoading: false,
      };

    // consent sms
    case TRIGGER_SMS_CONSENT_REQUEST:
      return {
        ...state,
        consetSMSLoading: true,
      };
    case TRIGGER_SMS_CONSENT_SUCCESS:
      return {
        ...state,
        consetSMSLoading: false,
      };
    case TRIGGER_SMS_CONSENT_FAILURE:
      return {
        ...state,
        consetSMSLoading: false,
      };

    default:
      return state;
  }
};

export default smsReducer;
export { initialState };